import * as React from 'react'

import { observer } from 'mobx-react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import type { DialogPortalContainer } from '~/client/src/shared/components/shadcn-ui/dialog'
import Localization from '~/client/src/shared/localization/LocalizationManager'

// localization: translated

interface IProps {
  isShown: boolean
  shouldBlockLateRequesting: boolean
  deadlineInterval: number
  portalContainer?: DialogPortalContainer

  onHide(): void
  onApply(): void
}

@observer
export default class BookingDeadlineDialog extends React.Component<IProps> {
  public render() {
    const {
      isShown,
      onHide,
      onApply,
      shouldBlockLateRequesting,
      deadlineInterval,
      portalContainer,
    } = this.props

    let title = Localization.translator.datePassedDeadline
    let applyButtonText = Localization.translator.requestAnyway
    let message = Localization.translator.thisRequestHasPassedTheDeadline

    if (shouldBlockLateRequesting) {
      title = Localization.translator.changeDate
      applyButtonText = Localization.translator.yesMoveTheDate
      message = Localization.translator.requestIsNotValid
    }

    return (
      <ConfirmDialog
        isOpen={isShown}
        title={title}
        onCancelClicked={onHide}
        onDoneClicked={onApply}
        doneTitle={applyButtonText}
        portalContainer={portalContainer}
      >
        <div className="tw:flex tw:flex-col tw:gap-2 tw:text-body-md tw:text-foreground">
          <div>{message}</div>
          <div>
            {Localization.translator.requestsMustBeInAdvance(deadlineInterval)}
          </div>
        </div>
      </ConfirmDialog>
    )
  }
}
